
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-primary/5 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="text-primary font-serif">
              <h1 className="font-bold text-2xl tracking-widest">MENEORA</h1>
              <p className="text-xs tracking-widest text-foreground/80">MENER À L'OR</p>
            </Link>
            <div className="mt-4 max-w-md">
              <p className="text-foreground/70">
                Quand quelque chose en toi appelle à évoluer, il existe un espace pour l'écouter.
              </p>
              <p className="mt-3 text-xs md:text-sm text-foreground/60 tracking-[0.2em] uppercase">
                Coaching · Hypnose · Bilan de compétences
              </p>
            </div>
          </div>
          
          <div>
            <h3 className="font-semibold text-lg text-primary mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li><a href="#home" className="text-foreground/70 hover:text-primary transition-colors">Accueil</a></li>
              <li><a href="#about" className="text-foreground/70 hover:text-primary transition-colors">À propos</a></li>
              <li><a href="#services" className="text-foreground/70 hover:text-primary transition-colors">Prestations</a></li>
              <li><a href="#testimonials" className="text-foreground/70 hover:text-primary transition-colors">Témoignages</a></li>
              <li><a href="#contact" className="text-foreground/70 hover:text-primary transition-colors">Contact</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold text-lg text-primary mb-4">Rejoignez-moi sur les réseaux :</h3>
            <div className="flex gap-4">
              <a 
                href="https://www.instagram.com/meredith_meneora/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-foreground hover:text-primary transition-colors"
              >
                <Instagram className="h-6 w-6" />
              </a>
              <a 
                href="https://www.facebook.com/meredithmeneora/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-foreground hover:text-primary transition-colors"
              >
                <Facebook className="h-6 w-6" />
              </a>
              <a 
                href="https://www.youtube.com/@Meredith_meneora" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-foreground hover:text-primary transition-colors"
              >
                <Youtube className="h-6 w-6" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-secondary/20 flex flex-col md:flex-row justify-between items-center">
          <p className="text-foreground/60 text-sm">
            📍 Étampes (Essonne) – ou en visio partout en France
          </p>
          <div className="mt-4 md:mt-0 flex space-x-4">
            <Link to="/mentions-legales" className="text-foreground/60 text-sm hover:text-primary transition-colors">
              Mentions légales
            </Link>
            <span className="text-foreground/60">|</span>
            <Link to="/cgv" className="text-foreground/60 text-sm hover:text-primary transition-colors">
              CGV
            </Link>
            <span className="text-foreground/60">|</span>
            <Link to="/politique-confidentialite" className="text-foreground/60 text-sm hover:text-primary transition-colors">
              Politique de confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
